import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
//
import { ExpandLess, ExpandMore, StarBorder } from '@mui/icons-material';
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, submenu } = item;
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  if (submenu) {
    return (
      <>
        <StyledNavItem onClick={handleOpen}>
          <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

          <ListItemText disableTypography primary={title} />
          {open ? <ExpandLess /> : <ExpandMore />}

          {info && info}
        </StyledNavItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {submenu.map((item) => (
              <NavSubItem key={item.title} subItem={item} />
            ))}
          </List>
        </Collapse>
      </>
    );
  }
  return (
    <>
      <StyledNavItem
        component={RouterLink}
        to={path}
        sx={{
          '&.active': {
            color: 'text.primary',
            bgcolor: 'action.selected',
            fontWeight: 'fontWeightBold',
          },
        }}
      >
        <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

        <ListItemText disableTypography primary={title} />

        {info && info}
      </StyledNavItem>
    </>
  );
}

NavSubItem.propTypes = {
  subItem: PropTypes.object,
};

function NavSubItem({ subItem }) {
  const { title, icon, path } = subItem;
  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        pl: 2,
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>
        <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
      </StyledNavItemIcon>
      <ListItemText disableTypography primary={title} />
    </StyledNavItem>
  );
}
